import { NavBar, Collapse } from 'bootstrap';
import 'swiper/swiper-bundle.min.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import isTouchDevice from './core/utils/isTouchDevice';
import getScrollbarWidth from './core/utils/getScrollbarWidth';
import MXShop from './core/mx-shop';
import RechargeInit from './app/components/recharge-init';
import './core/components/parallax';

import Header from './app/components/header';
import ProductSingleImages from './app/components/product-single-images';
import ProductRecommendations from './app/components/product-recommendations';

/** Sections Imports  */
import CardSlider from './app/sections/card-slider';
import CollectionProductGrid from './app/sections/collection-product-grid';
import FeaturedProducts from './app/sections/featured-products';
import HeroCarousel from './app/sections/hero-carousel';
import VideoModal from './app/sections/video-modal';
import MediaCarousel from './app/sections/media-carousel';
import ImageCollage from './app/sections/image-collage';
import FeaturedProductCarousel from './app/sections/featured-product-carousel';

// import AgeGate from "./app/components/age-gate";

if (isTouchDevice()) {
  document.body.classList.add('is-touch-device');
}
gsap.registerPlugin(ScrollTrigger);

/** Core Cart Functions  */
MXShop({
  cartAware: Shopify.theme.cartAwareProductForm,
  freeShipping: Shopify.theme.freeShippingEnabled,
  hasCartDrawer: Shopify.theme.cartDrawerEnabled,
  cartAlert: Shopify.theme.cartAlertEnabled,
});
/** // Core Cart Functions  */

// AgeGate();
Header();
ProductSingleImages();
ProductRecommendations();

/** Sections  */
FeaturedProducts();
CardSlider();
CollectionProductGrid();
HeroCarousel();
VideoModal();
MediaCarousel();
ImageCollage();
FeaturedProductCarousel();

RechargeInit();

document.addEventListener('shopify:section:load', function (evt) {
  FeaturedProducts();
});

document.body.style.setProperty(
  '--scrollbar-width',
  `${getScrollbarWidth()}px`,
);

